import React, { useEffect, useRef, useState } from "react";
import CollectionWidget from "./CollectionWidget";
import "./CollectionsRecommendRow.scss";

const CollectionsRecommendRow = ({ items = [], onOpen }) => {
  const scrollRef = useRef(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const safeItems = Array.isArray(items) ? items : [];

  const updateScrollState = () => {
    const el = scrollRef.current;
    if (!el) return;

    const { scrollLeft, scrollWidth, clientWidth } = el;

    setCanScrollLeft(scrollLeft > 5);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 5);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    updateScrollState();

    el.addEventListener("scroll", updateScrollState);
    window.addEventListener("resize", updateScrollState);

    return () => {
      el.removeEventListener("scroll", updateScrollState);
      window.removeEventListener("resize", updateScrollState);
    };
  }, [safeItems.length]);

  if (!safeItems.length) return null;

  const scrollCollections = (direction) => {
    const el = scrollRef.current;
    if (!el) return;

    el.scrollBy({
      left: direction === "left" ? -620 : 620,
      behavior: "smooth",
    });

    setTimeout(updateScrollState, 420);
  };

  return (
    <section className="collections-recs" aria-label="Підбірки для вас">
      <div className="collections-recs__head">
        <div>
          <h3 className="collections-recs__title">Підбірки по темах</h3>
          <p className="collections-recs__subtitle">
            Ми зібрали схожі оголошення
          </p>
        </div>
      </div>

      <div className="collections-recs__wrap">
        {canScrollLeft && (
          <button
            type="button"
            className="collections-recs__arrow collections-recs__arrow--left"
            onClick={() => scrollCollections("left")}
            aria-label="Прокрутити вліво"
          >
            ‹
          </button>
        )}

        <div className="collections-recs__scroll" ref={scrollRef}>
          {safeItems.map((collection) => (
            <CollectionWidget
              key={collection.id}
              collection={collection}
              onOpen={onOpen}
            />
          ))}
        </div>

        {canScrollRight && (
          <button
            type="button"
            className="collections-recs__arrow collections-recs__arrow--right"
            onClick={() => scrollCollections("right")}
            aria-label="Прокрутити вправо"
          >
            ›
          </button>
        )}
      </div>
    </section>
  );
};

export default CollectionsRecommendRow;